import GroupMemberButton from './GroupMemberButton';
import GroupMemberButtonContainer from './GroupMemberButton.container';

export default GroupMemberButtonContainer(GroupMemberButton);
